var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddDiary = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "105px",
    viewBox: "0 0 101 105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add Diary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-store",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[Live]-Invite-diary_empty-state",
    transform: "translate(-793.000000, -451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Diary",
    transform: "translate(793.500000, 451.332601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Combined-Shape",
    fill: "#029DD0",
    x: 0.000491212345,
    y: 5.8,
    width: 99.997788,
    height: 80.8981545,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 33.156472,
    y: 33.3428595,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 33.156472,
    y: 45.718824,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 33.156472,
    y: 58.0947885,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 33.156472,
    y: 70.470753,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 70.843528,
    y: 33.3428595,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 70.843528,
    y: 45.718824,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 70.843528,
    y: 58.0947885,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 70.843528,
    y: 70.470753,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 83.40588,
    y: 33.3428595,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 83.40588,
    y: 45.718824,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 83.40588,
    y: 58.0947885,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 83.40588,
    y: 70.470753,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 8.03176799,
    y: 33.3428595,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 8.03176799,
    y: 45.718824,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 8.03176799,
    y: 58.0947885,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 8.03176799,
    y: 70.470753,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 45.718824,
    y: 33.3428595,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 45.718824,
    y: 45.718824,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 45.718824,
    y: 58.0947885,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 45.718824,
    y: 70.470753,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 20.59412,
    y: 33.3428595,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 20.59412,
    y: 45.718824,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 20.59412,
    y: 58.0947885,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 20.59412,
    y: 70.470753,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 58.281176,
    y: 33.3428595,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 58.281176,
    y: 45.718824,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 58.281176,
    y: 58.0947885,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 58.281176,
    y: 70.470753,
    width: 8.562352,
    height: 8.562352,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,5.8 L95.9982793,5.8 C98.2074183,5.8 99.9982793,7.590861 99.9982793,9.8 L99.9982793,27.1478424 L99.9982793,27.1478424 L-7.10542736e-15,27.1478424 L-7.10542736e-15,9.8 C-7.37596886e-15,7.590861 1.790861,5.8 4,5.8 Z",
    id: "Rectangle",
    fill: "#054169"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 39.905212)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#054169",
    cx: 32,
    cy: 32,
    r: 27.52
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 8.000000)",
    fill: "#E5F8FD",
    id: "Control/link"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3483871,8 L25.6516129,8 C26.3575305,8 26.7870968,8.42956632 26.7870968,9.13548387 L26.7870968,21.2129032 L38.8645161,21.2129032 C39.5704337,21.2129032 40,21.6424695 40,22.3483871 L40,25.6516129 C40,26.3575305 39.5704337,26.7870968 38.8645161,26.7870968 L26.7870968,26.7870968 L26.7870968,38.8645161 C26.7870968,39.5704337 26.3575305,40 25.6516129,40 L22.3483871,40 C21.6424695,40 21.2129032,39.5704337 21.2129032,38.8645161 L21.2129032,26.7870968 L9.13548387,26.7870968 C8.42956632,26.7870968 8,26.3575305 8,25.6516129 L8,22.3483871 C8,21.6424695 8.42956632,21.2129032 9.13548387,21.2129032 L21.2129032,21.2129032 L21.2129032,9.13548387 C21.2129032,8.42956632 21.6424695,8 22.3483871,8 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#029DD0",
    x: 14.9991396,
    y: 0,
    width: 8,
    height: 16.4739212,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#029DD0",
    x: 76.9991396,
    y: 0,
    width: 8,
    height: 16.4739212,
    rx: 2
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddDiary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Add-Diary.88663d2a231e74080a5322dce3da1b19.svg";